module.exports = __webpack_public_path__ + "static/coronacollectiongif-02680ea1144278dc4d95e8cc2f7847fe.gif";